<template>
  <!-- sino das notificações (navbar e topo do celular): o ponto aparece com notificação não lida -->
  <!-- `label`: item de menu da navbar (ícone cinza + "Notificações"); sem label, só o sino (Home no celular) -->
  <button
    type="button"
    class="notification-bell"
    :class="{ 'nav-link text-paragraph d-flex align-items-center gap-2': label }"
    :id="id"
    aria-label="Notificações"
    @click="openNotifications"
  >
    <span class="position-relative d-inline-flex" :class="{ 'notification-bell-icon': label }">
      <PhIcons name="bell" :size="label ? 18 : size" color="primary" />
      <span v-if="hasUnread" class="notification-bell-dot rounded-circle" id="notification-bell-dot"></span>
    </span>
    <template v-if="label">Notificações</template>
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useNotifications } from "@/composables/useNotifications";
import { EOffcanvasViews, navigateCanvas } from "@/views/OffcanvasViews/OffcanvasViewsConfig";

withDefaults(defineProps<{ id?: string; size?: number; label?: boolean }>(), { id: "notification-bell", size: 26, label: false });
const { data } = useNotifications();
const hasUnread = computed(() => (data.value ?? []).some((n: any) => !n.read));
const openNotifications = () => navigateCanvas(EOffcanvasViews.notifications);
</script>

<style scoped lang="scss">
@import "@/assets/theme/scss/user-variables";

.notification-bell {
  border: 0;
  background: transparent;
  padding: 0;
  line-height: 0;
}

.notification-bell.nav-link {
  color: $primary50;
}

.notification-bell.nav-link:hover {
  color: $primary;
}

/* no menu: 18px e cinza, como os ícones inativos da tab bar (o PhIcons tem várias raízes, então o estilo vai no invólucro) */
.notification-bell.nav-link {
  line-height: inherit;
  padding-top: 0;
  padding-bottom: 0;
}

.notification-bell-icon :deep(svg) {
  width: 18px;
  height: 18px;
  opacity: 0.5;
}

.notification-bell-dot {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 9px;
  height: 9px;
  background: $danger;
  border: 2px solid $white;
}
</style>
